/* eslint-disable */
import React from 'react';
import useMediaQuery from 'src/hooks/useMediaQuery';

export const SNBLNav: React.FC = () => {
  const { isMobile } = useMediaQuery();
  return (
    <nav style={{ background: 'black' }} className={`w-100 d-flex align-center justify-content-between py-4 ${isMobile ? 'px-3' : 'px-6'}`}>
      <img className="img-fluid" src="/logo.svg" alt="ajocard-logo" />
    </nav>
  );
};
